var map = {
	"./inverno/brilhante/paleta.jpeg": 615,
	"./inverno/escuro/paleta.jpeg": 616,
	"./inverno/frio/paleta.jpeg": 617,
	"./outono/escuro/paleta.jpeg": 618,
	"./outono/quente/paleta.jpeg": 619,
	"./outono/suave/paleta.jpeg": 620,
	"./primavera/brilhante/paleta.jpeg": 621,
	"./primavera/clara/paleta.jpeg": 622,
	"./primavera/quente/paleta.jpeg": 623,
	"./verao/claro/paleta.jpeg": 624,
	"./verao/frio/paleta.jpeg": 625,
	"./verao/suave/paleta.jpeg": 626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;